export default "__VITE_ASSET__CGtff7MN__"